import React from "react";
import Link from "helpers/link";
import SearchProducts from "components/search-products";
import { useSelector } from "react-redux";
import { ReactComponent as Arrow } from "assets/svgs/arrow.svg";
import { useGlobalContext } from "context/global";

const BackToAllProducts = () => {
	const { translation } = useGlobalContext();
	const { subscriptionId } = useSelector((state) => state.account.subscription);

	return (
		<Link
			to={subscriptionId ? "/account/subscription/manage-products" : "/collections/all-products"}
			className="hd-screen-max-width flex gap-x-3 items-center lg:pb-2 text-body-xs text-secondary px-3 md:px-10 mt-3 md:mt-6"
		>
			<Arrow className="-rotate-90" />
			<span>{translation.product.all_products || "All Products"}</span>
		</Link>
	);
};

const Breadcrumb = ({ crumbs, title, path, showSearch }) => {
	if (path?.includes("/products")) return <BackToAllProducts />;
	if (!crumbs) return <></>;
	const mappedCrumbs = crumbs.map(({ pathname, crumbLabel }, idx) => ({
		pathname: pathname.replace("/en", ""),
		crumbLabel: idx === crumbs.length - 1 ? title || crumbLabel : crumbLabel
	}));

	const { isSearchOpen } = useSelector(state => state.filters);

	const disabledLinks = ["/products/gift-card"];

	return (
		<section className={`hd-screen-max-width flex justify-between items-center ${showSearch ? "h-11" : ""} lg:pb-2 text-body-xs text-[#757575] px-3 md:px-10 mt-3 md:mt-6`}>
			<nav className={`${isSearchOpen ? "hidden" : "flex"} lg:flex items-center flex-wrap`}>
				{mappedCrumbs.map(({ pathname, crumbLabel }, i) => (
					<div key={i}>
						<Link state={{ preserveScroll: true }} className="inline-block px-1 py-2"
							to={!disabledLinks?.includes(pathname) ? pathname : ""}>
							{crumbLabel}
						</Link>
						{i !== mappedCrumbs.length - 1 && <span className="mx-1 text-body-xs">&gt;</span>}
					</div>
				))}
			</nav>
			{showSearch && <SearchProducts hideInDesktop={true} />}
		</section>
	);
};

export default Breadcrumb;